import { FIXED2 } from "../../tools/fixedTools";
import { TTC2HT } from "../../tools/ttcConversion";
import { withHandlers } from "recompose";

export function prepareTaxLineFun(index, totalTTC, companyDefaultInfos) {
  //console.log("***prepareTaxLine=", index, totalTTC, companyDefaultInfos);

  const { tax1, tax2 } = companyDefaultInfos.company;

  if (index === 0 && tax1) {
    return {
      tax: { id: tax1.id, taux: tax1.valuePourcent },
      label: tax1.label,
      taux: tax1.valuePourcent,
      amount: FIXED2(totalTTC - TTC2HT(totalTTC, tax1.valuePourcent))
      // amount: (totalTTC * tax1.valuePourcent) / 100
    };
  } else if (index === 1 && tax2) {
    return {
      tax: { id: tax2.id, taux: tax2.valuePourcent },
      label: tax2.label,
      taux: tax2.valuePourcent,
      amount: FIXED2(totalTTC - TTC2HT(totalTTC, tax2.valuePourcent))
      // amount: (totalTTC * tax2.valuePourcent) / 100
    };
  }
  return {
    tax: "",
    label: "",
    taux: "",
    amount: 0.0
  };
}

export const prepareTaxLine = withHandlers({
  prepareTaxLine: () => prepareTaxLineFun
});
